<template>
    <li class="z-list-item" :class="{'root': this.root}">
        <div class="z-list-item__content">
            <slot/>
        </div>
    </li>
</template>

<script>
export default {
    name: 'z-list-item',
    props: {
        root: Boolean,
        tag: String
    }
}
</script>
